import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'app-simple-modal-header',
	templateUrl: './simple-modal-header.component.html',
	styleUrls: ['./simple-modal-header.component.scss']
})
export class SimpleModalHeaderComponent {

	@Output()
	dismissed = new EventEmitter<boolean>();

	@Input()
	pageTitle: string;

	constructor() { }

	dismiss() {
		this.dismissed.emit(true);
	}

}
